// Globally register all base components for convenience, since they will be used very frequently.
// Base components are in the components/_common/ folder and start by 'ld-' as in: LoanDolphin.

import Vue from 'vue';

// https://webpack.js.org/guides/dependency-management/#require-context
const requireComponent = require.context(
  // Look for files in the current directory
  './',
  // Do not look in subdirectories
  false,
  // Only include "_ld-" prefixed .vue files
  /ld-[\w-]+\.vue$/,
);

// For each matching file name...
requireComponent.keys().forEach((fileName) => {
  const locationRegex = /^\.\//; // find the "./" in the beginning
  const extensionRegex = /\.\w+$/; // find the file extension from the end
  const componentConfig = requireComponent(fileName);
  const componentName = fileName.replace(locationRegex, '').replace(extensionRegex, '');

  // Globally register the component
  Vue.component(componentName, componentConfig.default || componentConfig);
});
